import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PaginationService} from "./pagination.service";
import {TransactionType} from '../_models';

@Injectable()
export class InvoiceService extends PaginationService {
  constructor(protected http: HttpClient) {
    super(http, 'invoices');
  }

  charge(id: string | number, amount: string | number | null = null, isExternal: boolean = false,
         type: TransactionType = TransactionType.Charge) {
    return this.http.post(this.route + '/' + id.toString() + '/charge/',
      {amount: amount, is_external: isExternal, type: type});
  }

  price(id: string | number) {
    return this.http.get(this.route + '/' + id.toString() + '/price/');
  }

  regenerate(id: string | number) {
    return this.http.post(this.route + '/' + id.toString() + '/regenerate/', {});
  }

  split(id: string | number, splitDate: string) {
    return this.http.post(this.route + '/' + id.toString() + '/split/', {split_date: splitDate});
  }

  transferCredit(id: string | number, data: {}) {
    return this.http.post(this.route + '/' + id.toString() + '/transfer_credit/', data);
  }

  setBillingStartDate(id: string | number, billingStartDate: string) {
    return this.http.post(this.route + '/' + id.toString() + '/billing_date/',
      {billing_start_date: billingStartDate});
  }

  carryForward(id: string | number) {
    return this.http.post(this.route + '/' + id.toString() + '/carry_forward/', {});
  }

}
